import React from 'react';

const NormCartIcon = ({ className = "h-5 w-5 text-white" }) => (
  <svg className={className} viewBox="0 0 19 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 22.985V5.995L2 6v.03l17-.014v16.968H0zm17-15H2v13h15v-13zm-5-2.882c0-2.04-.493-3.203-2.5-3.203-2 0-2.5 1.164-2.5 3.203v.912H5V4.647C5 1.19 7.274 0 9.5 0 11.517 0 14 1.354 14 4.647v1.368h-2v-.912z" />
  </svg>
);

export default NormCartIcon;
